export const MAX_NAME_LENGTH = 30;
export const MAX_LASTNAME_LENGTH = 30;
export const MAX_MATERNAL_LASTNAME_LENGTH = 30;
export const MAX_EMAIL_LENGTH = 60;
export const MAX_ANOTHER_DATA = 30;
export const MAX_PHONE_LENGTH = 9;
export const MAX_RUT_WITHOUT_POINTS_OR_DASH = 9;
export const MAX_RUT_WITH_OR_WITHOUT_DASH = 10;
export const MAX_SERIAL_NUMBER = 10;
export const MAX_EXECUTIVE_CODE = 4;
